"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MediumForBrowserAdapter = (function () {
    function MediumForBrowserAdapter(mediumGroup) {
        var adaptedMedia = mediumGroup.mediumGroup.map(function (group) { return MediumForBrowserAdapter.makeSingleBrowserMedium(group); });
        adaptedMedia.length === 1
            ? this.setThisBrowserMediumAsSingle(adaptedMedia)
            : this.setThisBrowserMediumWithChildren(adaptedMedia, mediumGroup.groupTitle);
    }
    MediumForBrowserAdapter.makeSingleBrowserMedium = function (placement) {
        var medium = placement.medium;
        return {
            longTitle: medium.longTitle,
            shortTitle: medium.shortTitle || medium.longTitle,
            type: medium.type,
            key: medium.key,
            tag: placement.tag
        };
    };
    MediumForBrowserAdapter.prototype.setThisBrowserMediumAsSingle = function (media) {
        var newMedium = media[0];
        this.longTitle = newMedium.longTitle;
        this.shortTitle = newMedium.shortTitle;
        this.type = newMedium.type;
        this.key = newMedium.key;
        this.tag = newMedium.tag;
    };
    MediumForBrowserAdapter.prototype.setThisBrowserMediumWithChildren = function (media, groupTitle) {
        this.longTitle = groupTitle;
        this.shortTitle = groupTitle;
        this.children = media;
    };
    return MediumForBrowserAdapter;
}());
exports.MediumForBrowserAdapter = MediumForBrowserAdapter;
//# sourceMappingURL=mediumForBrowserAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/mediumForBrowserAdapter.js
// module id = 3
// module chunks = 0